/* 🤖 this file was generated by svg-to-ts */
export const mgcIconLineCuteRe: {
  name: 'line-cute-re';
  data: string;
} = {
  name: 'line-cute-re',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M19.64 3.068c-.158.053-1.179 1.06-8.345 8.226-7.546 7.546-8.17 8.181-8.23 8.363A1.353 1.353 0 0 0 3 20c0 .405.309.826.69.939.258.077.362.077.633-.002.213-.062.367-.213 8.384-8.23s8.168-8.171 8.23-8.384c.079-.271.079-.375.002-.633-.155-.523-.751-.809-1.299-.622"/></svg>`
};
